import { Component, Input, OnInit, inject } from '@angular/core';
import { InboundCall } from 'app/core/models/inbound-call.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { InboundCallsService } from 'app/core/services/inbound-calls.service';
import { keyedReasonOptions } from 'app/core/options/inbound-call-reasons.opts';
import { DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { RouterLink } from '@angular/router';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';

@Component({
    selector: 'app-inbound-call-log',
    templateUrl: './inbound-call-log.component.html',
    styleUrls: ['./inbound-call-log.component.scss'],
    imports: [PaginationHeaderComponent,
              RouterLink,
              PatientNameComponent,
              OfficeComponent,
              PaginationComponent,
              DatePipe]
})
export class InboundCallLogComponent implements OnInit {
  private inboundCallsService = inject(InboundCallsService);

  @Input() outboundFaxNumber: string;
  @Input() npi: string;

  inboundCalls: InboundCall[] = [];
  paging: LimitOffsetPaging;
  refreshing = false;

  keyedInboundCallReasonOptions = keyedReasonOptions;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadInboundCalls();
  }

  onPageSizeChange(size) {
    this.paging.pageSize = size;
    this.loadInboundCalls();
  }

  onPageChange(page) {
    this.paging.currentPage = page;
    this.loadInboundCalls();
  }

  private loadInboundCalls() {
    this.refreshing = true;
    this.inboundCallsService.getList(
      this.paging.currentPage,
      this.paging.pageSize,
      [],
      this.npi,
      this.outboundFaxNumber
    ).subscribe(result => {
      console.log(result);
      this.inboundCalls = result.inboundCalls;
      this.paging = result.meta.paging;
      this.refreshing = false;
    });
  }
}
